import { render, staticRenderFns } from "./draggable-item.vue?vue&type=template&id=093d2260&scoped=true&"
import script from "./draggable-item.vue?vue&type=script&lang=js&"
export * from "./draggable-item.vue?vue&type=script&lang=js&"
import style0 from "./draggable-item.vue?vue&type=style&index=0&id=093d2260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d2260",
  null
  
)

export default component.exports